import React, { useState, useRef, useEffect } from 'react';
import * as S from './styles';
import uploadFoto, { getViewableUrl } from '../../services/Colaborador/uploadFoto';
import { FormattedMessage } from 'react-intl';

const ImageUpload = ({ onUploadSuccess, initialImageUrl, idRede, colaboradorId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(initialImageUrl);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    // Usa a função getViewableUrl para garantir que a imagem possa ser exibida
    setPreview(getViewableUrl(initialImageUrl));
  }, [initialImageUrl]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setSelectedFile(null);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert('Por favor, selecione um arquivo de imagem.');
      return;
    }

    if (!idRede || !colaboradorId) {
      alert('É necessário buscar ou cadastrar um colaborador antes de enviar a foto.');
      return;
    }

    setUploading(true);

    try {
      // Usa o ID do colaborador para garantir um nome de arquivo único
      const fileExtension = selectedFile.name.split('.').pop();
      const blobName = `${colaboradorId}.${fileExtension}`;

      const response = await uploadFoto(selectedFile, idRede, blobName);

      onUploadSuccess(response.url); // Atualiza o estado no componente pai com a nova URL
      alert('Imagem enviada com sucesso!');
      setSelectedFile(null); // Limpa o arquivo selecionado após o upload

    } catch (error) {
      console.error('Erro ao fazer upload da imagem:', error);
      alert(`Ocorreu um erro durante o upload: ${error.message}`);
    } finally {
      setUploading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  return (
    <S.UploadContainer>
      <S.HiddenInput
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        ref={fileInputRef}
      />
      {preview ? (
        <S.ImagePreview src={preview} alt="Preview do Colaborador" onClick={triggerFileInput} />
      ) : (
        <div onClick={triggerFileInput} style={{ cursor: 'pointer' }}>
          <p><FormattedMessage id="upload.click_to_select" defaultMessage="Clique para selecionar uma imagem" /></p>
        </div>
      )}
      {selectedFile && (
        <S.UploadButton onClick={handleUpload} disabled={uploading}>
          {uploading ? <FormattedMessage id="upload.sending" defaultMessage="Enviando..." /> : <FormattedMessage id="upload.send_image" defaultMessage="Enviar Imagem" />}
        </S.UploadButton>
      )}
    </S.UploadContainer>
  );
};

export default ImageUpload;
